import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {ReplayVideoAction, SetVideoStateTypeAction} from '../../../shared/stores/root-store/actions/video.action';
import {selectActualVideoState, selectAudioTracksFromState} from '../../../shared/stores/root-store/selectors/video.selector';
import {VideoStateEnum} from '../../../../enums/video-state.enum';
import VideoState from '../../../shared/stores/root-store/video.state';
import AudioTrackModel from '../../../../models/audio-track.model';
import {IconType} from '../../../../enums/icon.enum';
import {AudioService} from '../../../shared/services/audio.service';
import {PlayerEventApiEnum} from '../../../../enums/playerEventApi.enum';
import {EventEmitterService} from '../../../shared/services/event-emitter.service';

@Component({
    selector: 'eocm-play-pause',
    templateUrl: './play-pause.component.html',
    styleUrls: ['./play-pause.component.scss']
})
export class PlayPauseComponent implements OnInit {
    videoStateType = VideoStateEnum.Pause;
    blockInteraction = VideoStateEnum.Interaction;
    icon = '';
    audioTracksList: AudioTrackModel[];

    constructor(
        private store: Store<{ video: VideoState }>,
        private audioService: AudioService,
        private eventEmitterService: EventEmitterService
    ) {
    }

    ngOnInit() {
        this.store.select(selectActualVideoState).subscribe(videoState => {
            this.videoStateType = videoState;
            this.icon = `pbi-icon-mini ${this.getClassIcon()} text-white`;

            if (this.videoStateType === VideoStateEnum.Ended) {
                this.audioService.resetAudioTracks(this.audioTracksList);
            }
        });
        this.store.select(selectAudioTracksFromState).subscribe(audioTracks => {
            this.audioTracksList = audioTracks;
        });
    }

    onButtonClick() {
        if (this.videoStateType !== this.blockInteraction) {
            if (this.videoStateType === VideoStateEnum.Ended) {
                this.replay();
            } else {
                const state = this.videoStateType === VideoStateEnum.UserPause
                    ? VideoStateEnum.Playing
                    : VideoStateEnum.UserPause
                ;

                this.store.dispatch(SetVideoStateTypeAction({
                    videoState: state
                }));

                if (state === VideoStateEnum.UserPause) {
                    this.eventEmitterService.emitEvent(PlayerEventApiEnum.VideoUserPaused, null);
                } else {
                    this.eventEmitterService.emitEvent(PlayerEventApiEnum.VideoUserResumed, null);
                }
            }
        }
    }

    getClassIcon() {
        return this.videoStateType === VideoStateEnum.Pause || this.videoStateType === VideoStateEnum.UserPause
            ? IconType.PLAY
            : this.videoStateType === VideoStateEnum.Ended
                ? IconType.REPLAY
                : IconType.PAUSE;
    }

    private replay() {
        this.store.dispatch(ReplayVideoAction());
        this.store.dispatch(SetVideoStateTypeAction({
            videoState: VideoStateEnum.Playing
        }));
    }
}
